import { render, staticRenderFns } from "./dialog_warp.vue?vue&type=template&id=1db53def&scoped=true&"
import script from "./dialog_warp.vue?vue&type=script&lang=js&"
export * from "./dialog_warp.vue?vue&type=script&lang=js&"
import style0 from "./dialog_warp.vue?vue&type=style&index=0&id=1db53def&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db53def",
  null
  
)

export default component.exports